import React, {
  createContext, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

export const ChatBotOpenContext = createContext(null);

export function ChatBotOpenProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const value = useMemo(
    () => ({
      isOpen,
      openChat: () => setIsOpen(true),
      closeChat: () => setIsOpen(false),
    }),
    [isOpen],
  );
  return (
    <ChatBotOpenContext.Provider value={value}>
      {children}
    </ChatBotOpenContext.Provider>
  );
}

ChatBotOpenProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
